import { Fragment, useCallback } from 'react';
import arrowLeft from '~/assets/icons/arrow_left_2.svg';
import { CurrencyIcon } from '~/components/collections';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import {
	setItemPageVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { AppAdsTypes } from '../AppAds/AppAds.model';
import { AppAdsItemPageClothes } from '../AppAdsItemPageClothes';
import { AppAdsItemPageVehicleHouse } from '../AppAdsItemPageVehicleHouse';
import {
	StyledBackButtonContent,
	StyledItemPrice,
	StyledTopContainer,
} from './AppAdsItemPage.styled';

const AppAdsItemPage = () => {
	const dispatch = useLayoutDispatch();
	const itemType = useLayoutSelector((state) => state.ads.itemType);
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	const handleClose = useCallback(() => {
		dispatch(setItemPageVisible(false));
	}, []);

	return (
		<Fragment>
			<StyledTopContainer>
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height40}
					style={{ fontSize: 14, width: 'fit-content' }}
					onClick={handleClose}
				>
					<StyledBackButtonContent>
						<img src={arrowLeft} />
						<Text>Вернуться назад</Text>
					</StyledBackButtonContent>
				</Button>
				<Text
					style={{
						fontSize: 14,
						fontWeight: 700,
						color: '#ffffff',
						textAlign: 'center',
					}}
				>
					BMW M2 G87
				</Text>
				<StyledItemPrice>
					<Text style={{ fontSize: 14, color: '#ffffff', opacity: 0.25 }}>
						Стоимость
					</Text>
					<Text style={{ fontSize: 14, color: '#ffffff', fontWeight: 700 }}>
						750 000
					</Text>
					<CurrencyIcon icon={rubleIcon} size="sm" />
				</StyledItemPrice>
			</StyledTopContainer>
			{(itemType === AppAdsTypes.Vehicle ||
				itemType === AppAdsTypes.Realty) && <AppAdsItemPageVehicleHouse />}
			{itemType === AppAdsTypes.Clothes && <AppAdsItemPageClothes />}
		</Fragment>
	);
};

export { AppAdsItemPage };
